import * as React from "react";
import { Spin, Button, Dropdown, Menu, Form } from "antd";
import FormTypesGrid from "./FormTypesGrid";
import DataGrid from "../../app/grid/DataGrid";
import { TApplicantReportingPeriodPresentationModel } from "../../../../presenter/applicants/model/ApplicantReportingPeriodPresentationModel";
import { TReportingPeriodFormTypePresentationModel } from "../../../../model/form/mappers/ReportingPeriodFormTypeListMapper";
import { TBoFormVersionPresentationModel } from "../../../../presenter/applicants/model/BoFormVersionPresentationModel";
import { IRegisteredApplicant } from "../../../../model/applicant/RegisteredApplicant";
import TickBox from "../../app/grid/TickBox";
import { ColumnProps } from "antd/lib/table";
import AdditionalEvaluationResultModal, {
  AdditionalEvaluationResultModalProps
} from "./AdditionalEvaluationResultModal";
import { IConfiguration } from "../../../../model/config/Configuration";

export interface State {
  additionalEvaluationFormVisible: boolean;
  selectedReportingPeriod?: TApplicantReportingPeriodPresentationModel;
  additionalEvaluationResult?: string;
}

export interface Props {
  reportingPeriods: TApplicantReportingPeriodPresentationModel[];
  translate: any;
  formTypes: TReportingPeriodFormTypePresentationModel[];
  formVersions: TBoFormVersionPresentationModel[];
  onExpandReportingPeriod: any;
  onExpandFormType: any;
  onExpandFormVersion?: any;
  formTypesLoader?: boolean;
  formVersionsLoader?: boolean;
  childrenLoader?: boolean;
  title: string;
  onChangeModalVisible?: any;
  applicant?: IRegisteredApplicant;
  addNewDraftFormVersion?: any;
  isApplicantForms?: boolean;
  isApplicantEvaluations?: boolean;
  updateAdditionalEvalutionResult?: (
    reportingPeriodApplicantId: number,
    result: string
  ) => void;
  getAdditionalEvaluationResult?: (
    reportingPeriodApplicantId: number
  ) => Promise<string | undefined>;
  configuration: IConfiguration;
}

export default class ReportingPeriodFormVersionGrid extends React.Component<
  Props,
  State
> {
  constructor(props) {
    super(props);
    this.state = {
      additionalEvaluationFormVisible: false
    };
  }

  hideAdditionalEvaluationForm() {
    this.setState({
      additionalEvaluationFormVisible: false
    });
  }

  showAdditionalEvaluationForm() {
    this.setState({
      additionalEvaluationFormVisible: true
    });
  }

  render() {
    const {
      reportingPeriods,
      translate,
      formTypes,
      onExpandReportingPeriod,
      onExpandFormType,
      formVersions,
      formTypesLoader,
      formVersionsLoader,
      onExpandFormVersion,
      childrenLoader,
      children,
      title,
      onChangeModalVisible,
      applicant,
      addNewDraftFormVersion,
      isApplicantForms,
      isApplicantEvaluations,
      updateAdditionalEvalutionResult,
      getAdditionalEvaluationResult,
      configuration
    } = this.props;

    const {
      additionalEvaluationFormVisible,
      selectedReportingPeriod,
      additionalEvaluationResult
    } = this.state;

    const AdditionEvalutionResultForm = Form.create<AdditionalEvaluationResultModalProps>(
      {}
    )(AdditionalEvaluationResultModal);

    let columns: ColumnProps<any>[] = [
      {
        title: translate(
          "applicantEvaluation_page.reporting_period.reporting_period_name"
        ),
        dataIndex: "reportingPeriodName",
        key: "reportingPeriodName"
      },
      {
        title: translate(
          "applicantEvaluation_page.reporting_period.reporting_type_name"
        ),
        dataIndex: "reportingTypeName",
        key: "reportingTypeName"
      },
      {
        title: translate(
          "applicantEvaluation_page.reporting_period.start_period"
        ),
        dataIndex: "fromPeriod",
        key: "fromPeriod",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(
            a.fromPeriod,
            b.fromPeriod
          ) as any
      },
      {
        title: translate(
          "applicantEvaluation_page.reporting_period.end_period"
        ),
        dataIndex: "toPeriod",
        key: "toPeriod",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.toPeriod, b.toPeriod) as any
      }
    ];

    if (isApplicantForms) {
      columns = [
        ...columns,
        {
          title: translate(
            "applicantEvaluation_page.reporting_period.is_evaluation_candidate"
          ),
          key: "isEvaluationCandidate",
          render: (text, record) => (
            <TickBox value={record.isEvaluationCandidate} />
          ),
          width: "5%"
        },
        {
          title: translate(
            "applicantEvaluation_page.reporting_period.evaluation_date"
          ),
          dataIndex: "evaluationDate",
          key: "evaluationDate",
          width: "7%",
          sorter: (a, b) =>
            DataGrid.SortHelper.compareDateString(
              a.evaluationDate,
              b.evaluationDate
            ) as any
        },
        {
          title: translate(
            "applicantEvaluation_page.reporting_period.evaluation_reason"
          ),
          dataIndex: "evaluationReason",
          key: "evaluationReason"
        },
        {
          title: translate(
            "applicantEvaluation_page.reporting_period.evaluation_status"
          ),
          dataIndex: "evaluationStatus",
          key: "evaluationStatus",
          width: "9%"
        },
        {
          align: "center",
          key: "actions",
          render: (text, record) =>
            record.isEvaluationCandidate ? (
              <Dropdown.Button
                onClick={(e) =>
                  onChangeModalVisible("statusAdditionalCheck", true, record)
                }
                overlay={
                  <Menu>
                    <Menu.Item
                      key={"1"}
                      onClick={async (e) => {
                        if (getAdditionalEvaluationResult) {
                          const result = await getAdditionalEvaluationResult(
                            record.id
                          );
                          this.showAdditionalEvaluationForm();
                          this.setState({
                            additionalEvaluationResult: result,
                            selectedReportingPeriod: record
                          });
                        }
                      }}
                    >
                      {translate(
                        "applicantForms_page.actions.additional_evaluation_result"
                      )}
                    </Menu.Item>
                  </Menu>
                }
              >
                {translate(
                  "applicantForms_page.actions.update_status_additional_check"
                )}
              </Dropdown.Button>
            ) : (
              <Button
                type={"primary"}
                onClick={(e) =>
                  onChangeModalVisible("additionalCheck", true, record)
                }
              >
                {translate("applicantForms_page.actions.additional_check")}
              </Button>
            )
        }
      ];
    }

    const onAdditionalEvalutionResultSubmit = (result: string) => {
      if (updateAdditionalEvalutionResult && selectedReportingPeriod) {
        updateAdditionalEvalutionResult(selectedReportingPeriod.id, result);
      }

      this.hideAdditionalEvaluationForm();
    };

    const expandedRowRender = (record, index, indent, expanded) => {
      return (
        <Spin spinning={formTypesLoader ? true : false}>
          <FormTypesGrid
            translate={translate}
            formTypes={formTypes}
            formVersions={formVersions}
            onExpandFormType={onExpandFormType}
            onExpandFormVersion={onExpandFormVersion}
            formVersionsLoader={formVersionsLoader}
            childrenLoader={childrenLoader}
            children={children}
            reportingPeriod={record}
            onChangeModalVisible={onChangeModalVisible}
            applicant={applicant}
            addNewDraftFormVersion={addNewDraftFormVersion}
            isApplicantForms={isApplicantForms}
            isApplicantEvaluations={isApplicantEvaluations}
            parentExpand={expanded}
            configuration={configuration}
          />
        </Spin>
      );
    };

    return (
      <div>
        <DataGrid
          title={title}
          translate={translate}
          columns={columns}
          dataSource={reportingPeriods}
          expandedRowRender={expandedRowRender}
          singleRowExpandEnabled={true}
          onExpand={onExpandReportingPeriod}
          booleanColumnKeys={
            isApplicantForms ? ["isEvaluationCandidate"] : undefined
          }
        />
        {updateAdditionalEvalutionResult && (
          <AdditionEvalutionResultForm
            translate={translate}
            visible={additionalEvaluationFormVisible || false}
            updateResult={onAdditionalEvalutionResultSubmit}
            onCancel={() => {
              this.hideAdditionalEvaluationForm();
              this.setState({ selectedReportingPeriod: undefined });
            }}
            result={additionalEvaluationResult}
          />
        )}
      </div>
    );
  }
}
